import styled, { css } from 'styled-components';
import { device } from '../configs/MediaQuery';

export const BaseStyles = css`
    cursor: pointer;
    border: none;
    border-radius: 8px;
    font-weight: 600;
    font-size: 20px;
    padding: 10px;
    display: flex;
    justify-content: center;
    align-items: center;

    @media ${device.mobileS} {
        //width: 100%;
    }

    @media ${device.tablet} {
        //width: auto;
    }
`;

export const PrimaryStyles = css`
    background-color: #35b0e6;
    color: #fff;
`;

export const SecondaryStyles = css`
    background-color: #f0f0f0;
    color: #4f4f4f;
`;

export const BorderStyles = css`
    color: #fff;
    border: solid 1px #54b4a4;
    border-bottom-width: 5px;
    background-color: transparent;
`;

export const DisabledStyle = css`
    color: #4f4f4f;
    background-color: #aab2bf;
    pointer-events: none;
`;

interface AppButtonProps {
    typeButton: boolean;
}
export const AppButton = styled.button.attrs((props: AppButtonProps) => ({
    className: props.typeButton
}))`
    &.primary {
        ${BaseStyles}
        ${PrimaryStyles}
    }
    &.secondary {
        ${BaseStyles}
        ${SecondaryStyles}
    }
    &.border {
        ${BaseStyles}
        ${BorderStyles}
    }
    &.disabled {
        ${BaseStyles}
        ${DisabledStyle}
    }
`;
